import reportsTableComponentUrl from './reportsTableComponent.html';

export default {
  bindings: {
    data: '<',
    rangeStart: '<',
    rangeEnd: '<',
    type: '<',
    mode: '<',
    columns: '<',
    canDataColumnBeVisible: '<',
    selectedLocationIds: '<',
    selectedPositionIds: '<',
    selectedUserIds: '<',
    selectedGroupIds: '<',
    sortMethod: '=?orderBy',
    showDurationsAsDecimals: '<',
    totalsModeEnabled: '<',
    filtersOpened: '<',
    statsOpened: '<',
    schema: '<',
    toggleCollapse: '=',
    getDataForExport: '=?',
    collapsedGroups: '=',
  },
  controllerAs: 'ctrl',
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "reports" */ './reportsTableComponentCtrl')).default,
  templateUrl: reportsTableComponentUrl,
};
